"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.collectTimeZoneInfo = exports.currentTimeStamp = exports.getTime = void 0;
exports.getTime = () => {
    return new Date().getTime();
};
exports.currentTimeStamp = () => {
    return new Date().toJSON();
};
exports.collectTimeZoneInfo = () => {
    const tzOffset = new Date().getTimezoneOffset();
    let o = Math.abs(tzOffset);
    if (isDST(new Date())) {
        o += 60;
    }
    const offset = `${tzOffset < 0 ? '+' : '-'}${`00${Math.floor(o / 60)}`.slice(-2)}:${`00${o % 60}`.slice(-2)}`;
    return {
        timezone: offset,
    };
};
const stdTimezoneOffset = () => {
    const b = new Date(new Date().getFullYear(), 0, 1);
    const a = new Date(new Date().getFullYear(), 6, 1);
    return Math.max(b.getTimezoneOffset(), a.getTimezoneOffset());
};
const isDST = (date) => {
    const d = new Date(date);
    return d.getTimezoneOffset() < stdTimezoneOffset();
};
//# sourceMappingURL=time.js.map